import { render, staticRenderFns } from "./UpdateDeliveryOrder.vue?vue&type=template&id=09be3494&"
import script from "./UpdateDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./UpdateDeliveryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports